import axios from "axios";

export const API_INTERNAL_URL = "http://143.198.5.94:8080";
const { REACT_APP_MY_ENV } = process.env;

const axiosInstance = axios.create({
  baseURL: REACT_APP_MY_ENV,
});
export function signIn(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/login",
      data: {
        email: credentials.email,
        password: credentials.password,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          console.log(response.data);
          sessionStorage.setItem("token_store", JSON.stringify(response.data));
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        console.log("ERROR");
        reject(error);
      });
  });
}

export function authenticateWithGoogle(credential) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/social/google/authenticate",
      data: {
        credential,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          if (response.data?.token) {
            sessionStorage.setItem(
              "token_store",
              JSON.stringify(response.data.token)
            );
          }

          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function resetPassword(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/reset-password",
      data: {
        email: credentials.email,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}

export function authChangePassword(credentials) {
  return new Promise((resolve, reject) => {
    axiosInstance({
      method: "post",
      url: "/change-password",
      data: {
        token: credentials.token,
        password: credentials.password,
        confirmPassword: credentials.confirmPassword,
      },
    })
      .then((response) => {
        if (response.status === 200) {
          resolve(response.data);
        }
        reject(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  });
}
